function TaskDirective() {
  return {
    restrict: 'EA',
    scope: {
      tasks: '=',
      orgTask: '=',
      clientView: '=',
      callBackParent: '&'
    },
    templateUrl: 'directives/task.html',
    controller: function ($scope, $rootScope, OrganizationService, CommonService, $sce, dragulaService) {
      'ngInject';

      $scope.uploadFiles = function(files, errFiles) {
        $scope.attachments = files;
      };

      $scope.editDirectiveTask = function (taskId, orgId) {
        $scope.callBackParent({type: 'edit', data: { taskId: taskId,  parentId: orgId}});
      };

      $scope.addAttachView = function(taskId){
        $scope.callBackParent({type: 'addAttachmentView',data: { taskId: taskId}});
      };

      $scope.assignView = function(taskId){
        $scope.callBackParent({type: 'assignTaskView',data: { taskId: taskId }});
      };

      $scope.deleteChecklistAndTask = function (taskId, parentId) {
        $scope.callBackParent({type: 'delete',data: { taskId: taskId,  parentId: parentId}});
      };

      $scope.removeImage = function(taskId, orgId, file){
        $scope.callBackParent({type: 'deleteAttachment',data: { taskId: taskId, attachmentId: orgId , parentId: file}});
      };

      $scope.completeTask = function(taskId, orgId, status){
        $scope.callBackParent({type: 'updateStatus', data: { taskId: taskId ,parentId: orgId, taskStatus: status }});
      };

      $scope.getAttachmentClass = function (url) {
        return CommonService.attachmentClass(url);
      };

      //for task drag and drop by handle(:::) only
      dragulaService.options($scope, 'container', {
        revertOnSpill: true,
        moves: function (el, container, handle) {
          return handle.className.includes('handle');
        }
      });

      //task drop event
      $scope.$on('container.drop', function (e, el, target, source) {
        var domIndex = Array.prototype.indexOf.call(angular.element(target).children(), el[0]);
        if (domIndex != -1) {
          var parentId = target[0].id;
          var elementId = el[0].id;
          var replacedTask = $scope.tasks[domIndex];
          $scope.callBackParent({ type: 'rearrangeTask', data: { taskId: elementId, position: replacedTask.position, parentId: parentId } });
        }
      });
    }
  };
}
export default {
  name: 'taskDirective',
  fn: TaskDirective
};
